import React, { useEffect, useState } from "react";
import { INITIAL_PROPOSAL_CARDS_COUNT } from "../../common/constants/common.constants";
import { INftListingData } from "../../common/interfaces/proposals.interface";
import ListedNftItem from "../../components/Marketplace/ListedNftItem/ListedNftItem";
import SkeletonItem from "../../components/SkeletonItem/SkeletonItem";
import { getAllListings } from "../../solana/common/helpers/marketplace";
import { generateSkeletonArrays } from "../../utilities/helpers";

const Marketplace = () => {
  const [listedNfts, setListedNfts] = useState<INftListingData[]>();

  useEffect(() => {
    void getAllListedNfts();
  }, []);

  const getAllListedNfts = async () => {
    try {
      setListedNfts(await getAllListings());
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {listedNfts ? (
        <div>
          {listedNfts.map((nft) => {
            return (
              <ListedNftItem nftListing={nft} key={nft.offer.toString()} />
            );
          })}
        </div>
      ) : (
        <div className="marketplace__skeleton">
          {generateSkeletonArrays(INITIAL_PROPOSAL_CARDS_COUNT).map((item) => {
            return <SkeletonItem key={item} height={200} width={150} />;
          })}
        </div>
      )}
    </>
  );
};

export default Marketplace;
